import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import { STORAGE_CONSTANTS, USER_REGISTRATION_TYPE } from 'PospModule/Constants'
import { userState } from 'PospModule/Constants/userRegistrationStatus'
import { type IAuthenticatedUser } from 'PospModule/Models/ResponseModels'
import { storageService } from 'PospModule/Services/storage.service'

// interface IUserStateObject {
//   status: number;
//   key: string;
//   remark: string;
//   data: any;
// }

// interface IUserStateObjects extends Array<any> {}

interface IState {
  authenticatedUser: IAuthenticatedUser
  isLoggedIn: boolean
  userState: any
  isRegistered: string
  activeKey: string
  broker: string
  examResult: any
  journeyType: 'LIFE' | 'GENERAL'
}

const initialState: IState = {
  authenticatedUser:
    storageService.getValueFromLocalStorage(STORAGE_CONSTANTS.AUTHENTICATED_USER) ?? {},
  isLoggedIn: !!storageService.getValueFromLocalStorage(STORAGE_CONSTANTS.AUTHENTICATED_USER),
  userState,
  isRegistered: USER_REGISTRATION_TYPE.notRegistered,
  activeKey: '',
  broker: '',
  examResult: null,
  journeyType: 'LIFE',
}

const userSlice = createSlice({
  name: 'pospUser',
  initialState,
  reducers: {
    updateUserDetails: (state, action: PayloadAction<IAuthenticatedUser>) => {
      state.authenticatedUser = action.payload
      state.isLoggedIn = true
      storageService.setValueInLocalStorage(STORAGE_CONSTANTS.AUTHENTICATED_USER, action.payload)
    },
    updateUserState: (store, action: PayloadAction<any>) => {
      store.userState = action.payload
    },
    updateUserActiveKey: (store, action: PayloadAction<any>) => {
      store.activeKey = action.payload
    },
    updateUserPospStatus: (state, action: PayloadAction<any>) => {
      state.isRegistered = action.payload
    },
    updateUserBroker: (state, action: PayloadAction<any>) => {
      state.broker = action.payload
    },
    updateExamResult: (state, action: PayloadAction<any>) => {
      state.examResult = action.payload
    },
    updateJourneyType: (state, action: PayloadAction<'LIFE' | 'GENERAL'>) => {
      state.journeyType = action.payload
    },
    updatePanNumber: (state, action: PayloadAction<any>) => {
      state.authenticatedUser.pan_number = action.payload
    },
    resetUser: (state) => {
      storageService.removeValueFromLocalStorage(STORAGE_CONSTANTS.AUTHENTICATED_USER)
      state.authenticatedUser = initialState.authenticatedUser
      state.isLoggedIn = false
      state.userState = userState
      state.isRegistered = USER_REGISTRATION_TYPE.notRegistered
      state.examResult = null
      state.journeyType = 'LIFE'
    },
  },
})

const { reducer } = userSlice
const {
  updateUserDetails,
  resetUser,
  updateUserState,
  updateUserPospStatus,
  updateUserBroker,
  updateUserActiveKey,
  updateExamResult,
  updatePanNumber,
  updateJourneyType,
} = userSlice.actions

export {
  reducer as pospUserReducer,
  updateUserDetails,
  resetUser,
  updateUserState,
  updateUserPospStatus,
  updateUserBroker,
  updateUserActiveKey,
  updateExamResult,
  updatePanNumber,
  updateJourneyType,
}
